var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTickDarkTeal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_3915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9583 4.31417C23.9065 5.43902 25.5271 7.05318 26.6598 8.99685C27.7924 10.9405 28.3978 13.1463 28.4159 15.3958C28.4341 17.6453 27.8644 19.8606 26.7634 21.8223C25.6623 23.784 24.0679 25.4242 22.1382 26.5803C20.2084 27.7365 18.0102 28.3686 15.761 28.4142C13.5119 28.4597 11.2899 27.917 9.31493 26.8399C7.33997 25.7627 5.68058 24.1884 4.50103 22.2729C3.32147 20.3573 2.66265 18.1669 2.58979 15.9185L2.58333 15.5L2.58979 15.0815C2.66213 12.8508 3.31125 10.6769 4.47387 8.7717C5.63649 6.86653 7.27293 5.29513 9.22365 4.21068C11.1744 3.12624 13.3728 2.56576 15.6046 2.5839C17.8365 2.60204 20.0255 3.19816 21.9583 4.31417ZM20.2882 12.0035C20.0658 11.7811 19.7699 11.6475 19.456 11.6277C19.1421 11.608 18.8317 11.7035 18.5832 11.8963L18.4618 12.0035L14.2083 16.2556L12.5382 14.5868L12.4168 14.4796C12.1683 14.2869 11.858 14.1916 11.5441 14.2114C11.2303 14.2312 10.9345 14.3648 10.7121 14.5871C10.4898 14.8095 10.3562 15.1053 10.3364 15.4191C10.3166 15.733 10.4119 16.0433 10.6046 16.2918L10.7118 16.4132L13.2951 18.9965L13.4165 19.1038C13.6431 19.2795 13.9216 19.3749 14.2083 19.3749C14.495 19.3749 14.7736 19.2795 15.0001 19.1038L15.1215 18.9965L20.2882 13.8299L20.3954 13.7085C20.5882 13.4599 20.6837 13.1496 20.6639 12.8357C20.6442 12.5218 20.5106 12.2259 20.2882 12.0035Z",
    fill: "#007A78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_3915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickDarkTeal);
export default __webpack_public_path__ + "static/media/Icon_Tick_DarkTeal.ef590ef7786f16a2d7e714293656b9b1.svg";
export { ForwardRef as ReactComponent };